export const VALUES = {
    TODAY: 'today',
    TOMORROW: 'tomorrow',
} as const;
